export type RmaRegistrationPayload = {
  nukiId: string;
  email: string;
  firstName?: string;
  lastName?: string;
  deviceUuid: string;
};

export const RMA_REGISTRATION_ERROR = {
  ALREADY_ACTIVATED: 'ALREADY_ACTIVATED',
  VALIDATION: 'VALIDATION',
  UNKNOWN: 'UNKNOWN',
} as const;

export type RmaRegistrationError =
  (typeof RMA_REGISTRATION_ERROR)[keyof typeof RMA_REGISTRATION_ERROR];

export type RmaRegistrationResult =
  | { success: true }
  | { success: false; error: RmaRegistrationError };
